import React from 'react';

const ErrorNotification = ({ formik, field }) => {
	if (
		Object.prototype.hasOwnProperty.call(formik.errors, field) &&
		Object.prototype.hasOwnProperty.call(formik.touched, field)
	) {
		return <div className="input-error">{formik.errors[field]}</div>;
	}
	return false;
};

export default ErrorNotification;
